const { get, adminCall } = require("./_utils")
const { waitForStream } = require("../utils/helpers/streaming.js")

/**
 *
 * @param {String} projectUid
 * @param {Object} file file description
 * @param {Sbject} file.name file name
 * @param {Sbject} file.ext file extension
 * @param {Buffer} file.data file data
 * @param {Object} options options
 * @param {Function} options.slicer slicer function
 * @param {Number} options.chunksize slice size
 * @param {Function} options.onProgress progress callback
 * @returns {Promise<String>} file uuid
 */
async function uploadFile(projectUid, { name, ext, data }, { slicer, chunksize, onProgress } = null) {
  const totalByteLength = data.byteLength

  let getChunks = slicer(data, chunksize || 8192)

  let uploadEvent
  try {
    uploadEvent = await global.socket.request("project.uploadFile", { projectUid, name, ext })
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }

  const uid = uploadEvent

  let uploadedBytes = 0
  do {
    let { value, done } = getChunks.next()
    let chunk = done ? null : await value
    uploadEvent = await global.socket.request(uploadEvent, chunk).catch(err => console.log(err))
    uploadedBytes += chunk ? chunk.byteLength : 0
    if (typeof onProgress === "function") onProgress(uploadedBytes, totalByteLength)
  } while (uploadEvent)

  return uid
}

module.exports = {
  // project management
  create: data => adminCall("project.create", data),
  modify: data => adminCall("project.modify", data),
  remove: uid => adminCall("project.remove", { uid }),

  // user management
  addUser: data => adminCall("project.addUser", data),
  removeUser: data => adminCall("project.removeUser", data),
  updateAllUsers: data => adminCall("project.updateAllUsers", data),

  // roles/licences
  setRole: data => adminCall("project.setRole", data),
  updateAllLicencesAndRoles: data => adminCall("project.updateAllLicencesAndRoles", data),

  // project actions
  open: projectUid => global.socket.request("project.open", { projectUid })
    .then(streamUid => waitForStream(global.socket, streamUid)),

  close: projectUid => global.socket.request("project.close", { projectUid }),

  // project files handlers
  uploadFile,
  removeFile: ({ uid, fileUid }) => adminCall("project.removeFile", { uid, fileUid }),

  // task actions
  removeTask: ({ uid, taskUid }) => adminCall("project.removeTask", { uid, taskUid }),

  // download module
  module: async (licenceUid, moduleKey, filename) => {
    try {
      let file = await get("/project/module", {
        params: {
          licenceUid,
          moduleKey,
          filename
        },
        responseType: 'blob',
        timeout: null,
        headers: {
          "Cache-Control": "public"
        }
      }, true);
      return file.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}